import React from 'react'

const Qualitysystem = () => {
  return (
     <div className="pcb-container">
      <div className="pcb-text">
        <h2>Quality System</h2>
        <p style={{ fontSize: '19px', lineHeight: '1.6' ,color:"black"}}>
At Automotive Devices, quality is at the heart of everything we do. Our ISO 9001 and ISO 13485 certifications reflect our unwavering commitment to maintaining the highest standards in PCB assembly across diverse industries, including the highly regulated medical sector.

From the moment raw materials enter our facility to the final stage of product testing, our rigorous Quality Management Systems ensure precision, consistency, and complete traceability. Every step of our production process is designed to minimize defects and maximize reliability.

Equipped with advanced inspection technologies like Automated Optical Inspection (AOI), X-ray verification, and in-circuit testing, we verify that every board meets the most stringent performance and safety requirements. Our proactive quality control measures not only detect issues early but also drive continuous improvement across operations.

Whether it’s a one-off prototype or high-volume production, you can rely on Automotive Devices to deliver excellence, accountability, and peace of mind—every single time. We don’t just meet standards; we aim to exceed them.
        </p>
      </div>
      <div className="pcb-image">
        <img src='/images (1).jpeg' alt="PCB Assembly" />
      </div>
    </div>
  )
}

export default Qualitysystem
